import { useState } from "react";
import ActionButton from "../../components/query/button";
import StatusTabs from "../../components/query/statusTab";

import QueriesGrid from "../../components/query/queriesGrid";

const allQueriesData = [
  {
    id: 123,
    category: "Salary Discrepancy",
    date: "10/15/2023",
    status: "Active",
  },
  {
    id: 124,
    category: "Leave Request",
    date: "10/15/2023",
    status: "Resolved",
  },
  {
    id: 125,
    category: "Job Role Changes",
    date: "10/15/2023",
    status: "Pending",
  },
  {
    id: 126,
    category: "Retirement Benefits",
    date: "10/15/2023",
    status: "Active",
  },
  // duplicate or fetch more
];

const AllQueries = () => {
  const [activeTab, setActiveTab] = useState("Active");

  const filteredQueries =
    activeTab === "All"
      ? allQueriesData
      : allQueriesData.filter((q) => q.status === activeTab);

  return (
    <div className="max-w-7xl mx-auto min-h-screen px-6 py-10">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h1 className="text-3xl font-semibold">All Queries</h1>
          <p className="text-gray-500 mt-1">
            Here are all the queries received on CeHR platform
          </p>
        </div>

        <ActionButton label="Export Queries" />
      </div>

      <div className="flex gap-4 mt-6">
        <StatusTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      <QueriesGrid queries={filteredQueries} />
    </div>
  );
};

export default AllQueries;
